import React, { useState, useEffect, useContext, useMemo } from 'react';
//@ts-ignore
import * as styles from './ProductSideBySide.module.css';
//@ts-ignore
import ArrowLgButton from '../Global/ArrowLgButton';
import {
    getMediaData,
    getMultiChoice,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    imagePreset,
    getDisplayDimensions,
} from '../Global/DataUtils';
import CtaLink from '../Global/CtaLink';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { ProductSideBySideProps } from './index';
import { BuildLinkHref } from '../Global/BuildLinkHref';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import RichText from '../Global/RichText';
import {
    ProductDescription,
    ProductDetailMastheadData,
    ProductSpecifications,
} from '../../templates/StructuredDataContext';
import PlainTextElement from '../Global/Headlines';
import { getLangPrefix, supportedRegionCodes } from '../../global/countries';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
interface Props extends ProductSideBySideProps {
    content: ProductPagePreview[];
}

const ProductSideBySide: React.FC<Props> = ({
    headline,
    kontentItemId,
    ...props
}) => {
    const breakpoints = useBreakpoint();
    const [currentProductPage, setCurrentProductPage] = useState(0);
    const [isWideXl, setIsWideXl] = useState(false);

    useEffect(() => {
        if (breakpoints.xl) {
            const checkWidth = () => setIsWideXl(window.innerWidth > 1400);
            checkWidth();
            window.addEventListener('resize', checkWidth);
            return () => window.removeEventListener('resize', checkWidth);
        }
        setIsWideXl(false);
    }, [breakpoints.xl]);

    const productsToShow = useMemo(
        () => getProductsToShow(breakpoints, isWideXl),
        [breakpoints, isWideXl]
    );
    const [currentPosition, setCurrentPosition] = useState(0);
    const selectProductPages = props.content?.slice(
        currentPosition,
        currentPosition + productsToShow
    );
    const [selectedProductPages, setSelectedProductPages] =
        useState(selectProductPages);

    const dotsToShow = breakpoints.sm
        ? Math.ceil(props.content?.length / productsToShow)
        : props.content?.length;

    const description = props.description;

    const ctaShowHide =
        getMultiChoice(props?.show_or_hide_cta) === 'show' &&
        props?.cta_configuration__cta_label?.value;
    const ctaWindowAction =
        getMultiChoice(props?.cta_configuration__cta_window_action) ===
        'new_window'
            ? '_blank'
            : undefined;
    const isSecondaryCtaStyle =
        getMultiChoice(props?.cta_styling) === 'secondary';
    const ctaLink = BuildLinkHref(
        props?.cta_configuration__cta_location,
        props?.cta_configuration__cta_location_anchor_point
    );

    let linkHref = ctaLink;
    const pageMetadata = useContext(PageMetadataContext);
    const preferredLanguage = pageMetadata.preferredLanguage || 'default';
    linkHref = linkHref ? `${getLangPrefix(preferredLanguage)}${linkHref}` : '';
    useEffect(() => {
        setSelectedProductPages(props.content?.slice(0, productsToShow));
        setCurrentPosition(0);
        setCurrentProductPage(0);
    }, [productsToShow]);

    const handleClickNext = () => {
        let newProductPage = currentProductPage + 1;
        let newPosition = currentPosition + productsToShow;

        let newSelectedProducts = props.content?.slice(
            newPosition,
            newPosition + productsToShow
        );

        setSelectedProductPages(newSelectedProducts);
        setCurrentPosition(newPosition);
        setCurrentProductPage(newProductPage);
    };

    const handleClickPrev = () => {
        let newProductPage = currentProductPage - 1;
        let newPosition = currentPosition - productsToShow;

        let newSelectedProducts = props.content?.slice(
            newPosition,
            newPosition + productsToShow
        );

        setSelectedProductPages(newSelectedProducts);
        setCurrentPosition(newPosition);
        setCurrentProductPage(newProductPage);
    };

    const renderPrevButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="left"
            handleClick={handleClickPrev}
            className={styles.prevArrowButton}
        />
    );

    const renderNextButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="right"
            handleClick={handleClickNext}
            className={styles.nextArrowButton}
        />
    );

    const renderDots = (dotsToShow: number, currentProductPage: number) => {
        let dots = [];

        for (let i = 0; i < dotsToShow; i++) {
            dots.push(
                <span
                    key={i}
                    style={
                        currentProductPage == i ? { background: '#ccc' } : {}
                    }
                ></span>
            );
        }

        return dots;
    };

    const renderProductPageCard = (
        productPageCard: ProductPagePreview,
        cardIdx: number
    ) => {
        var productUrl = productPageCard.elements?.slug?.url;
        if (
            productPageCard?.elements?.slug?.url &&
            productPageCard?.preferred_language
        ) {
            let splittedPagePath =
                productPageCard?.elements?.slug?.url?.split('/');
            let splittedPagePathCountryCode =
                productPageCard?.elements?.slug?.url?.split('/')[1];
            //@ts-ignore
            const saunaPagePathContainsCountrySlug: boolean =
                supportedRegionCodes.indexOf(splittedPagePathCountryCode) > -1
                    ? true
                    : false;
            if (saunaPagePathContainsCountrySlug) {
                let pagePathWithoutCountryCode =
                    '/' + splittedPagePath.slice(2).join('/');
                productUrl = pagePathWithoutCountryCode;
            }
            productUrl =
                getLangPrefix(productPageCard?.preferred_language) + productUrl;
        }
        const productSpecifications =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_specifications'
            )[0] as ProductSpecifications | undefined;
        const productDescription =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_description'
            )[0] as ProductDescription;
        const productDetailMasthead =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_detail_masthead'
            )[0] as ProductDetailMastheadData;

        const productCapacity =
            productSpecifications?.elements?.specs?.value[0]?.elements.capacity
                ?.value[0]?.elements?.capacity_value?.value;
        const aslowastext =
            productSpecifications?.elements?.specs?.value[0]?.elements
                ?.financing_info_copy?.value;

        const aslowasprice =
            productSpecifications?.elements?.specs?.value[0]?.elements
                ?.financing_cost?.value;
        const productCapacityIcon =
            productSpecifications?.elements?.specs?.value[0]?.elements.capacity
                ?.value[0]?.elements?.icon?.value[0]?.elements?.icon_svg_file
                .value[0]?.url;

        const productImage = getMediaData(
            productSpecifications?.elements?.gallery_images
        );

        return (
            <a href={productUrl} key={cardIdx} className={styles.productCard}>
                <div data-kontent-element-codename="product_image">
                    <img
                        className={styles.productImage}
                        src={optimizeKontentImageUrl(productImage?.url, {
                            ...imagePreset.card.mobile,
                            q: 95,
                        })}
                        srcSet={buildKontentSrcSet(
                            productImage?.url,
                            imagePreset.card.mobile.w,
                            { fm: 'webp' as const, q: 95 }
                        )}
                        sizes="280px"
                        {...getDisplayDimensions(
                            productImage?.width,
                            productImage?.height,
                            280
                        )}
                        alt={
                            productSpecifications?.elements?.product_name
                                ?.value || ''
                        }
                        loading="lazy"
                        decoding="async"
                    />
                </div>

                <h5 className={styles.productName}>
                    {productSpecifications?.elements?.product_name?.value ??
                        productSpecifications?.elements?.headline?.value ??
                        productDetailMasthead?.elements?.display_headline
                            ?.value}
                </h5>
                {productCapacityIcon && (
                    <img
                        src={productCapacityIcon}
                        alt=""
                        width={24}
                        height={24}
                        loading="lazy"
                        decoding="async"
                    />
                )}
                <div className={styles.capacity}>
                    <p>{productCapacity}-Person Capacity</p>
                    {aslowasprice && aslowastext && (
                        <p>
                            {aslowastext}{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {aslowasprice}
                            </span>
                        </p>
                    )}
                </div>
            </a>
        );
    };

    return (
        <div className={styles.wrapper} data-kontent-item-id={kontentItemId}>
            <div className={styles.content}>
                {headline?.value && (
                    <h2>
                        <PlainTextElement
                            text={headline}
                            elementCodename="headline"
                        />
                    </h2>
                )}

                <div className={styles.description}>
                    {RichText(
                        description,
                        false,
                        undefined,
                        undefined,
                        'description'
                    )}
                </div>
            </div>
            <div id={styles.galleryWrapper} className={styles.content}>
                <div id={styles.gallery} className={styles.gallery}>
                    {currentProductPage > 0 && renderPrevButton()}
                    <div className={styles.galleryProducts}>
                        {selectedProductPages?.map(
                            (ProductPagePreview, cardIdx) => {
                                return renderProductPageCard(
                                    ProductPagePreview,
                                    cardIdx
                                );
                            }
                        )}
                    </div>

                    {props.content?.length > currentPosition + productsToShow &&
                        renderNextButton()}
                </div>

                {dotsToShow > 1 && (
                    <div className={styles.dots}>
                        {renderDots(dotsToShow, currentPosition)}
                    </div>
                )}
            </div>
            {ctaShowHide && (
                <div className={styles.ctaContainer}>
                    {isSecondaryCtaStyle ? (
                        <div className={styles.secondaryCtaStyle}>
                            <a
                                href={linkHref}
                                target={ctaWindowAction}
                                rel={
                                    ctaWindowAction === '_blank'
                                        ? 'noopener noreferrer'
                                        : undefined
                                }
                            >
                                <span
                                    className={styles.productName}
                                    data-kontent-element-codename="cta_configuration__cta_label"
                                >
                                    {props.cta_configuration__cta_label?.value}
                                    {' >'}
                                </span>
                            </a>
                        </div>
                    ) : (
                        <div className={styles.standardCta}>
                            <CtaLink
                                href={ctaLink}
                                target={ctaWindowAction}
                                visualStyle="outlineDark"
                            >
                                {props.cta_configuration__cta_label?.value}
                            </CtaLink>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProductSideBySide;

function getProductsToShow(
    breakpoints: { [key: string]: boolean },
    isWideXl: boolean
) {
    switch (true) {
        case breakpoints.xl:
            return isWideXl ? 5 : 4;
        case breakpoints.l:
            return 3;
        case breakpoints.md:
            return 2;
        case breakpoints.sm:
            return 1;
        default:
            return 1;
    }
}
